import { Injectable } from '@angular/core';
import { ToastMessageEmitterService, ToastSeverity } from '@taures/taures-components/taures-toast';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  public constructor(private readonly toastMessageEmitterService: ToastMessageEmitterService) {}

  public showUserErrorToast(message: string): void {
    this.toastMessageEmitterService.publishToastMessage({
      message: message,
      sticky: true,
      severity: ToastSeverity.USER_OPERATION_ERROR
    });
  }

  public showTechnicalErrorToast(message: string): void {
    this.toastMessageEmitterService.publishToastMessage({
      message: message,
      sticky: true,
      severity: ToastSeverity.TECHNICAL_ERROR
    });
  }

  public showSuccessToast(message: string): void {
    this.toastMessageEmitterService.publishToastMessage({ message: message, severity: ToastSeverity.SUCCESS });
  }

  public showInfoToast(message: string): void {
    this.toastMessageEmitterService.publishToastMessage({ message: message, severity: ToastSeverity.INFO });
  }
}
